(function(){
  function init(root){
    if(!root || root.dataset.cdmInitialized==='true') return;
    root.dataset.cdmInitialized='true';
    var main=root.querySelector('.cdm-lc__main-img');
    root.querySelectorAll('.cdm-lc__thumb').forEach(function(btn){btn.addEventListener('click',function(){if(main)main.src=btn.dataset.src;root.querySelectorAll('.cdm-lc__thumb').forEach(function(x){x.classList.remove('is-active')});btn.classList.add('is-active')})});
    var buy=root.querySelector('[data-cdm-buy]');
    root.querySelectorAll('.cdm-lc__scroll').forEach(function(btn){btn.addEventListener('click',function(){if(buy){buy.scrollIntoView({behavior:'auto',block:'center'});window.dispatchEvent(new Event('scroll'))}})});
    var slider=root.querySelector('.cdm-lc__review-slider'),track=root.querySelector('.cdm-lc__review-slider-track'),slides=[].slice.call(root.querySelectorAll('.cdm-lc__review-slide')),dots=[].slice.call(root.querySelectorAll('.cdm-lc__review-slider-dots i')),index=0,timer;
    function showReview(n){if(!track||!slides.length)return;index=(n+slides.length)%slides.length;var step=slides[0].getBoundingClientRect().width+12;track.style.transform='translateX('+(-index*step)+'px)';dots.forEach(function(d,i){d.classList.toggle('is-active',i===index)})}
    function startReviews(){clearInterval(timer);if(slides.length>1)timer=setInterval(function(){showReview(index+1)},4200)}
    if(slider&&track&&slides.length){var prev=root.querySelector('.cdm-lc__review-prev'),next=root.querySelector('.cdm-lc__review-next');if(prev)prev.addEventListener('click',function(){showReview(index-1);startReviews()});if(next)next.addEventListener('click',function(){showReview(index+1);startReviews()});slider.addEventListener('mouseenter',function(){clearInterval(timer)});slider.addEventListener('mouseleave',startReviews);window.addEventListener('resize',function(){showReview(index)});showReview(0);startReviews()}
    var sticky=root.querySelector('.cdm-lc__sticky');
    if(sticky&&buy){
      function updateSticky(){var rect=buy.getBoundingClientRect();sticky.classList.toggle('is-visible',rect.bottom<0)}
      window.addEventListener('scroll',updateSticky,{passive:true});
      window.addEventListener('resize',updateSticky);
      if('IntersectionObserver'in window)new IntersectionObserver(updateSticky,{threshold:.05}).observe(buy);
      updateSticky();
    }    var sectionId=root.dataset.sectionId;
    var ctaBtn=root.querySelector('.cdm-lc__cta');
    var variantInput=root.querySelector('input[name="id"]');
    var priceEl=root.querySelector('.cdm-lc__prices strong');
    var compareEl=root.querySelector('.cdm-lc__prices s');
    var discountEl=root.querySelector('.cdm-lc__prices span');
    var stickyPrice=root.querySelector('.cdm-lc__sticky strong');
    var soldOutLabel=root.dataset.soldOutLabel||'NO DISPONIBLE';
    var ctaLabel=root.dataset.ctaLabel||'PEDIR AHORA';
    function formatMoney(cents){return(cents/100).toLocaleString('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0})}
    function onVariantChange(variant){
      if(!variant)return;
      if(variantInput)variantInput.value=variant.id;
      if(ctaBtn){ctaBtn.disabled=!variant.available;ctaBtn.textContent=variant.available?ctaLabel:soldOutLabel;}
      if(priceEl)priceEl.textContent=formatMoney(variant.price);
      if(stickyPrice)stickyPrice.textContent=formatMoney(variant.price);
      if(compareEl){if(variant.compare_at_price&&variant.compare_at_price>variant.price){compareEl.textContent=formatMoney(variant.compare_at_price);compareEl.style.display='';}else{compareEl.style.display='none';}}
      if(discountEl){if(variant.compare_at_price&&variant.compare_at_price>variant.price){var pct=Math.round((variant.compare_at_price-variant.price)*100/variant.compare_at_price);discountEl.textContent='\u2193 '+pct+'% OFF';discountEl.style.display='';}else{discountEl.style.display='none';}}
    }
    document.addEventListener('variant:change',function(e){
      if(!sectionId||!e.detail)return;
      if(e.detail.sectionId&&e.detail.sectionId!==sectionId)return;
      onVariantChange(e.detail.variant);
    });
    document.addEventListener('change',function(e){
      if(!e.target.closest)return;
      var form=e.target.closest('.cdm-lc__form');
      if(!form||!form.closest('[data-cdm-native]'))return;
      var variantData=root.dataset.variants;
      if(!variantData)return;
      var variants=JSON.parse(variantData);
      var selected={};
      form.querySelectorAll('select[name^="options"], input[type="radio"][name^="options"]:checked').forEach(function(el){selected[el.name]=el.value;});
      var match=variants.find(function(v){return v.options.every(function(opt,i){return selected['options['+i+']']===opt;});});
      if(match)onVariantChange(match);
    });


  }
  function initAll(scope){(scope||document).querySelectorAll('[data-cdm-native]').forEach(init)}
  initAll(document);
  if(!window.__cdmNativeSectionListener){window.__cdmNativeSectionListener=true;document.addEventListener('shopify:section:load',function(e){initAll(e.target)})}
})();
// Variant selector
document.querySelectorAll('[data-cdm-native]').forEach(function(section){
  var form = section.querySelector('.cdm-lc__form');
  if(!form) return;
  var variantInput = form.querySelector('[data-variant-id]');
  if(!variantInput) return;
  var variantsData = JSON.parse(section.dataset.variants || '[]');
  var selected = {};

  section.querySelectorAll('.cdm-lc__opt-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var pos = btn.dataset.optionPosition;
      var val = btn.dataset.value;
      selected[pos] = val;
      // Update active state
      section.querySelectorAll('.cdm-lc__opt-btn[data-option-position="'+pos+'"]').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      // Find matching variant
      var match = variantsData.find(function(v){
        return v.options.every(function(o, i){
          var p = String(i+1);
          return selected[p] === undefined || selected[p] === o;
        });
      });
      if(match){ variantInput.value = match.id; }
    });
  });
});
